import { stopTrace } from 'utils/performance/trace';
import { TraceName } from 'utils/performance/types';

export const traceFirstMenuItemLoaded = (additionalMetadata?: Record<string, string>) => {
  stopTrace(
    TraceName.STORE_LOCATOR_ORDER_HERE_TO_MENU_ITEMS_DISPLAYED_STORE_ALREADY_SELECTED,
    additionalMetadata
  );
  stopTrace(
    TraceName.STORE_LOCATOR_ORDER_HERE_TO_MENU_ITEMS_DISPLAYED_STORE_NOT_ALREADY_SELECTED,
    additionalMetadata
  );
  stopTrace(TraceName.MENU_LOAD, additionalMetadata);
  stopTrace(TraceName.MENU_SECTION_LOAD, additionalMetadata);
};
